// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-field-label__label--required:after{content:\"*\";display:inline-block;color:var(--color-rosso);margin-left:4px;transform:translateY(3px)}.message-field-label__info-icon{display:inline-block;margin-left:4px}.message-field-label__info-icon svg.ui-icon{vertical-align:top !important}.message-field-label__popover-content{max-width:332px}", ""]);
// Exports
module.exports = exports;
